import {Flex, rem, Text, Tooltip} from "@mantine/core";
import {IconInfoCircleFilled} from "@tabler/icons-react";
import React from "react";

interface Props {
    value: string
    label: string
    popover: string
}

export default function ReportInfoCounterCard(props: Props) {
    return (
        <Flex direction={'column'} gap={rem(8)} flex={1}>
            <Flex direction={'row'} align={'center'} gap={rem(6)}>
                <Text
                    fw={600}
                    fz={rem(13)}
                    lh={rem(16)}
                    c={'#6F767E'}
                >
                    {props.label}
                </Text>

                <Tooltip
                    multiline
                    w={220}
                    withArrow
                    transitionProps={{duration: 200}}
                    label={props.popover}
                >
                    <IconInfoCircleFilled color={'#6F767E'} size={14}/>
                </Tooltip>
            </Flex>
            <Text
                fw={600}
                fz={rem(32)}
                lh={rem(40)}
                c={'#1A1D1F'}
            >
                {props.value}
            </Text>
        </Flex>
    )
}